import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useToast } from '../hooks/useToast';
import { Button } from '../components/ui/Button';

export function LoginPage() {
  const [pin, setPin] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { login } = useAuth();
  const { showToast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (pin.length < 4) {
      showToast('PIN must be at least 4 digits.');
      return;
    }
    setIsSubmitting(true);
    try {
      await login(pin);
    } catch (err: any) {
      showToast(`Login failed: ${err.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-[var(--bg-primary)]">
      <div className="flex flex-1 items-center justify-center p-4 sm:p-6">
        <div className="w-full max-w-sm">
          {/* Brand */}
          <div className="mb-6 flex flex-col items-center text-center">
            <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-[var(--radius)] bg-[var(--accent-color)]">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5z" /><path d="M2 17l10 5 10-5" /><path d="M2 12l10 5 10-5" />
              </svg>
            </div>
            <h1 className="text-[1.375rem] font-semibold tracking-[-0.02em] text-[var(--text-main)]">
              SKD Body Quality Control
            </h1>
            <p className="mt-1.5 text-[0.875rem] text-[var(--text-muted)]">
              Five-stage inspection and defect tracking for incoming chassis bodies.
            </p>
          </div>

          <div className="card p-5 sm:p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="form-group">
                <label className="form-label" htmlFor="pin">Inspector PIN</label>
                <input
                  id="pin"
                  type="password"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  className="input-field text-center font-mono text-lg tracking-[0.4em]"
                  placeholder="••••••"
                  maxLength={6}
                  value={pin}
                  onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
                  autoFocus
                />
                <span className="field-hint">Ask an administrator if you don&rsquo;t have one.</span>
              </div>
              <Button
                type="submit"
                variant="primary"
                className="w-full"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Signing in…' : 'Sign in'}
              </Button>
            </form>
          </div>

          <p className="mt-5 text-center text-[0.75rem] text-[var(--text-dim)]">
            Internal quality system · Authorised personnel only
          </p>
        </div>
      </div>
    </div>
  );
}
